"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $body = void 0;

var number_with_commas = void 0;

$body = require("../helpers/helpers").default.body;

number_with_commas = require("../helpers/number_with_commas").default;

var Team_Page = function Team_Page() {
  _classCallCheck(this, Team_Page);

  this.$month_total = $(".total-per-month");
  this.$year_total = $(".total-per-year");
  this.$team_members = $(".team_members");
  this.$form = $("#team_members");
  this.$enterprise = $(".enterprise");
  this.$enterprise_link = $("#team_members .text-link");
  this.get_value = function () {
    this.val = this.$team_members.val();
    if (this.val === "" || this.val === 0) {
      this.val = 1;
    }
    return this.val;
  };
  this.animateTo = function ($this, animation_time) {
    return $body.animate({
      scrollTop: $this.offset().top
    }, animation_time);
  };
  this.configure_seat_field = function () {
    return this.$team_members.on("keydown", function (e) {
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 || e.keyCode === 65 && e.ctrlKey === true || e.keyCode === 67 && e.ctrlKey === true || e.keyCode === 88 && e.ctrlKey === true || e.keyCode >= 35 && e.keyCode <= 39) {
        return;
      }
      if (e.shiftKey || e.keyCode < 48 || e.keyCode > 57 && e.keyCode < 96 || e.keyCode > 105) {
        return e.preventDefault();
      }
    });
  };
  this.process_seats = function () {
    var val = void 0;
    val = this.get_value();
    if (val > 24) {
      this.$enterprise_link.removeClass("peekaboo");
    } else {
      this.$enterprise_link.addClass("peekaboo");
    }
    this.$month_total.html(number_with_commas((val * 9.99).toFixed(2)));
    return this.$year_total.html(number_with_commas((val * 39.99).toFixed(2)));
  };

  var me = void 0;
  me = this;
  this.configure_seat_field();
  this.$team_members.on("keyup", function (_this) {
    return function () {
      return _this.process_seats();
    };
  }(this));
  this.$enterprise.on("click", function (e) {
    return me.animateTo($($(this).attr("href")));
  });

  $("#select_team_members").on("click", function (_ref) {
    var $form = _ref.$form;
    return function (e) {
      e.preventDefault();
      return $form.submit();
    };
  }(this));
};

exports.default = Team_Page;